import React, { useState } from 'react';

import IonIcon from '@reacticons/ionicons';


const PoradaItem = ({ title, content }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IonIcon 
        name={isHovered ? 'flash' : 'bulb'} 
        className="porada-icon" 
      />
      <strong>{title}</strong> {content}
    </li>
  );
};

const PralkiPorady = () => {
  const porady = [
    { title: "Pralka nie dopiera dobrze:", content: "Możliwe, że jest uszkodzona grzałka lub pasek napędowy. Awarię grzałki można sprawdzić..." },
    { title: "Woda zostaje w pralce:", content: "Najczęstszą przyczyną jest zapchany filtr. Awarię często można usunąć samemu. Filtry znajdują się..." },
    { title: "Przedmiot wpadł pod bęben pralki:", content: "W przypadku pralek z wsadem od góry, czasami drobne przedmioty mają tendencję do wpadania..." },
    { title: "Bęben się nie kręci:", content: "Przyczyną najprawdopodobniej są zużyte szczotki silnika. Aby uniknąć ich szybkiego zużycia..." },
    { title: "Pralka się trzęsie podczas wirowania:", content: "Jeśli nie przekroczyliśmy zalecanej ilości prania - 3/4 bębna dla lekkich materiałów..." },
    { title: "Po pobraniu wody - pralka się zatrzymuje:", content: "Częsty objaw przepalonej grzałki. Pralka nie kontynuuje prania, bo czeka na zagrzanie wody." },
    { title: "Pralka głośno wiruje:", content: "Najczęstszym powodem jest wytarty gumowy simmering, który ma za zadanie uszczelniać łożysko bębna..." },
    { title: "Czarne plamy wewnątrz pralki:", content: "Jest to pleśń żywiąca się płynem do płukania. Aby jej uniknąć warto robić pranie czyszczące..." },
    { title: "Pralka wyłącza prąd w mieszkaniu:", content: "Powodem najczęściej jest zwarcie wywołane przez niesprawną grzałkę." },
    { title: "Po praniu zostaje proszek na ubraniach:", content: "Pralka nie ogrzewa wody lub zerwany jest pasek napędowy." },
    { title: "Jaką pralkę kupić, gdy koszt naprawy starej jest zbyt wysoki?", content: "Polecam zakup dobrej niemieckiej pralki marki Bosch lub Siemens. Pralki innych firm..." },
    { title: "Stanowczo odradzam zakup pralki ładowanej od góry:", content: "Ich największym problemem jest otwierający się bęben w czasie prania..." },
    { title: "Gdzie postawić pralkę:", content: "Pralka nie powinna stać w zabudowie lub przylegać do innych cennych elementów łazienki." },
  ];

  return (
    <div className="PralkiPorady">
      <h2>Moje porady - najczęstsze usterki pralek:</h2>
      <ul className="PoradyList">
        {porady.map((porada, index) => (
          <PoradaItem key={index} title={porada.title} content={porada.content} />
        ))}
      </ul>
    </div>
  );
}

export default PralkiPorady;
